const ServiceDashboard = () => import('@/views/main/serviceDashboard/index.vue')
export default {
  path: '/main/serviceDashboard',
  name: 'ServiceDashboard',
  component: ServiceDashboard,
  children: []
}
